// utils/crypto.js

export async function encrypt(text) {
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  const iv = window.crypto.getRandomValues(new Uint8Array(12)); // Initialization vector
  const generatedKey = await window.crypto.subtle.generateKey(
    {
      name: "AES-GCM",
      length: 256,
    },
    true,
    ["encrypt", "decrypt"]
  );
  const encrypted = await window.crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: iv,
    },
    generatedKey,
    data
  );
  const exportedKey = await window.crypto.subtle.exportKey("jwk", generatedKey);
  return {
    iv: Array.from(iv),
    data: Array.from(new Uint8Array(encrypted)),
    key: exportedKey,
  };
}

export async function decrypt(encrypted) {
  const { iv, data, key } = encrypted;
  const ivArray = new Uint8Array(iv);
  const dataArray = new Uint8Array(data);
  const importedKey = await window.crypto.subtle.importKey(
    "jwk",
    key,
    {
      name: "AES-GCM",
    },
    true,
    ["decrypt"]
  );
  const decrypted = await window.crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: ivArray,
    },
    importedKey,
    dataArray
  );

  const decoder = new TextDecoder();
  return decoder.decode(decrypted);
}

export async function generateKey() {
  return window.crypto.subtle.generateKey(
    {
      name: "AES-GCM",
      length: 256,
    },
    true,
    ["encrypt", "decrypt"]
  );
}
/**
 *
 * @param {*} key
 * @param {*} value
 */
export const setItemToStorage = async (type = "localStorage", key, value) => {
  const keyData = await generateKey();
  const encryptedData = await encrypt(value, keyData);
  const storage = window[type];
  storage.setItem(key, encryptedData);
};
export const getItemFromStorage = async (type = "localStorage", key) => {
  const storage = window[type];
  const encryptedData = storage.getItem(key);
  const keyData = await generateKey();
  return await decrypt(encryptedData, keyData);
};
